<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="100px">
    <div class="flex-item">
      <el-form-item label="是否发布" prop="state">
        <el-radio-group v-model="form.state">
          <el-radio :label="'是'">是</el-radio>
          <el-radio :label="'否'">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="主题" prop="fTitle">
        <el-input v-model="form.fTitle" :disabled="isEdit" />
      </el-form-item>

      <el-form-item label="消息内容" prop="fDes">
        <el-input v-model="form.fDes" type="textarea" />
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import md5 from 'md5'

export default {
  props: {
    form: Object
  },
  data: function() {
    return {
      rules: {
        state: [{ required: true, message: '必填项', trigger: 'change' }],
        fTitle: [{ required: true, message: '必填项', trigger: 'change' }],
        fDes: [{ required: true, message: '必填项', trigger: 'change' }]
      }
    }
  },
  computed: {
    isEdit: function() {}
  },
  mounted: function() {
    // console.log(this.form, "form");
  },
  methods: {
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          var data = Object.assign({}, this.form)

          onValid(data)
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.flex-item {
  // display: flex;
  // width: 95%;
  // & > .el-form-item {
  //   flex: 0 0 25%;
  //   display: flex;

  //   & .el-input,
  //   &.el-select {
  //     width: 100%;
  //   }
  // }
}
</style>
